import * as actionTypes from "../action-types";

const initialState = {
    termsofUseData: null,
    privacyPolicyData: null,
    refundPolicyData: null,
    aboutUsData: null,
};

const staticpageReducer = (state = initialState, actions) => {
    const { payload, type } = actions;

    switch (type) {
        //! Static Page
        case actionTypes.SET_TERMS_OF_USE:
            return { ...state, termsofUseData: payload };

        case actionTypes.SET_PRIVACY_POLICY:
            return { ...state, privacyPolicyData: payload };

        case actionTypes.SET_REFUND_POLICY:
            return { ...state, refundPolicyData: payload };

        case actionTypes.SET_ABOUT_US:
            return { ...state, aboutUsData: payload };

        default:
            return state;
    }
};

export default staticpageReducer;